import { WageType } from "@/enums";

export default class Wage {
  public id: number;

  /**
   * The identifier of the wage period in the v3 employee API. Only set on wages loaded from it, which in turn
   * have no numeric `id`.
   */
  public uuid?: string;

  public wage: number;

  public wageType: WageType;

  public validFrom: string;

  public validTo: string;

  public targetHours: number | null;
}
